export default __webpack_public_path__ + "static/1824-545427dd62ff1b9b50f8cfd04d4be040.gif";